module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-11.daf23737.png";